// API Configuration Settings for different environments
const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.africafilmfinanceforum.com';
  } else {
    return 'http://localhost:5000';
  }
};

export const API_SETTINGS = {
  // Base URLs with environment handling
  BASE_URL: getBaseUrl(),
  API_PREFIX: '/api',
  
  // Get full API URL with prefix
  get API_URL() {
    return `${this.BASE_URL}${this.API_PREFIX}`;
  },
  
  // Categorized endpoints
  ENDPOINTS: {
    // Auth related endpoints
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      RESET_PASSWORD: '/auth/reset-password',
    },
    
    // User and contact related endpoints
    USER: {
      PROFILE: '/users/profile',
      UPDATE: '/users/update',
    },
    
    // Forms related endpoints
    FORMS: {
      CONTACT: '/contact',
      NEWSLETTER: '/subscribe',
      EXHIBITION: '/exhibition',
      FILM_SCREENING: '/film-screening',
      FINANCIER_ACCREDITATION: '/financier-accreditation',
      MASTERCLASS_ENROLLMENT: '/masterclass-enrollment',
      PITCH_SUBMISSION: '/pitch-submission',
      INDUSTRY_ACCREDITATION: '/accreditation/industry',
    },
    
    // Payment related endpoints
    PAYMENTS: {
      INITIATE: '/payments/initiate',
      VERIFY: '/payments/verify',
      HISTORY: '/payments/history',
    },
    
    // Content related endpoints
    CONTENT: {
      MASTERCLASSES: '/masterclasses',
      SPEAKERS: '/speakers',
      EVENTS: '/events',
      DEALS: '/deals',
    },
  },
  
  // Request Configuration
  REQUEST_CONFIG: {
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 2000,
  },
  
  // Headers
  HEADERS: {
    DEFAULT: {
      'Content-Type': 'application/json',
    },
    MULTIPART: {
      // Remove Content-Type to let the browser set it correctly with boundary
    },
    WITH_AUTH: () => ({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    }),
  },
};

// Helper function to construct full API URLs
export const getApiUrl = (endpoint) => {
  // Make sure we handle endpoints that already start with a slash
  const formattedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_SETTINGS.API_URL}${formattedEndpoint}`;
}; 